/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState } from 'react';
import API from '@/common/util/api';

type Props = {
  offset?: number,
  limit?: number,
  items: API.IAddress[],
  handleSetAddress: Function, // 住所の通知用
};

// 住所検索モーダルの結果表示とページング部分（郵便番号、都道府県市区町村検索で共通）
const SearchResultList: React.FC<Props> = ({
  offset = 0,
  limit = 8,
  items,
  handleSetAddress,
}) => {
  // 表示内容の件数
  const [currentOffset, setCurrentOffset] = useState(offset);

  const showNextBatch = () => {
    setCurrentOffset(currentOffset + limit);
  };

  const showPrevBatch = () => {
    setCurrentOffset(currentOffset - limit);
  };

  function hasNext(): boolean {
    return items.length > (currentOffset + limit);
  }

  function hasPrev(): boolean {
    return currentOffset !== 0;
  }

  // 検査結果から選択
  function setAddressAndPostal(address: API.IAddress) {
    handleSetAddress(address);
  }

  return (
    <div className="column is-full">
      {
        items.length > 0
          ? (
            <>
              <ul className="is-margin-left-0 is-margin-top-0 is-margin-bottom-0 is-padding-3 is-padding-wide-0">
                {items.slice(currentOffset, currentOffset + limit).map((address, index) => (
                  <li
                    className="is-padding-2 is-padding-wide-0 is-margin-top-0"
                    key={`postalresult_${currentOffset + index}`}
                  >
                    <a
                      role="button"
                      onClick={() => setAddressAndPostal(address)}
                    >
                      {`${address.prefecture}${address.city} ${address.town}${address.block}`}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          ) : <p className="has-text-danger">候補が見つかりませんでした。検索しなおしてください。</p>
      }
      <div className="level is-mobile">
        <div className="level-left" />
        <div className="level-right">
          <div className="level-item is-margin-right-0">
            <div className={hasPrev() || hasNext() ? '' : 'is-hidden'}>
              <a
                className={hasPrev() ? '' : 'is-hidden'}
                type="button"
                onClick={showPrevBatch}
              >
                前のページ
              </a>
              <span> | </span>
              <a
                className={hasNext() ? '' : 'is-hidden'}
                type="button"
                onClick={showNextBatch}
              >
                次のページ
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResultList;
